module.exports = __webpack_public_path__ + "static/media/banner_news_conlicitaseg.ae5e1088.png";